import styled from 'styled-components';

const H3 = styled.div`
    font-size: 2.3rem;
`;

export default H3;